import { useNavigate } from "react-router-dom";
import { useLanguage } from "../LanguageProvider/LanguageProvider";

const SubsidyClaimRegistration = () => {
  const navigate = useNavigate();
  const { language } = useLanguage(); // true = Hindi, false = English

  const content = {
    heading: {
      en: "Subsidy Claim / Registration",
      hi: "अनुदान दावा / पंजीकरण",
    },
    subHeading: {
      en: "Flow Chart",
      hi: "प्रवाह चार्ट",
    },
    loginStep: {
      en: "Login Through CAF ID",
      hi: "CAF आईडी के माध्यम से लॉगिन करें",
    },
    option1: {
      title: {
        en: "Register for Incentive",
        hi: "प्रोत्साहन हेतु पंजीकरण",
      },
      desc: {
        en: "Under Construction Stage",
        hi: "निर्माणाधीन चरण में",
      },
    },
    option2: {
      title: {
        en: "Apply For Incentive",
        hi: "प्रोत्साहन हेतु आवेदन करें",
      },
      desc: {
        en: "After Completion & Commercial Operation of Project",
        hi: "परियोजना पूर्ण होने एवं व्यावसायिक संचालन प्रारंभ होने के बाद",
      },
    },
  };

  return (
    <div className="flex flex-col items-center space-y-6 p-6">
      {/* Heading */}
      <div className="bg-white text-center py-4 px-6 rounded-md w-full max-w-xl shadow-md">
        <h2 className="text-2xl font-bold text-theme-color">
          {language ? content.heading.hi : content.heading.en}
        </h2>
        <p className="text-lg mt-1 text-theme-color">
          {language ? content.subHeading.hi : content.subHeading.en}
        </p>
      </div>

      {/* Website URL */}
      <div className="bg-white text-center py-3 px-4 rounded-md w-full max-w-xl shadow-md">
        <a
          href="https://uttarakhandtourism.gov.in"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline text-[#018f9b] font-medium"
        >
          https://uttarakhandtourism.gov.in
        </a>
      </div>

      {/* Login Step */}
      <div className="bg-white text-center py-3 px-4 rounded-md w-full max-w-xl shadow-md font-semibold text-theme-color">
        {language ? content.loginStep.hi : content.loginStep.en}
      </div>

      {/* Two Options */}
      <div className="flex flex-col md:flex-row gap-6 w-full max-w-xl">
        <div
          className="bg-white text-center py-4 px-6 rounded-md flex-1 shadow-md cursor-pointer hover:scale-105 transition-transform"
          onClick={() => navigate("/login")}
        >
          <h3 className="font-semibold text-lg text-theme-color">
            {language
              ? content.option1.title.hi
              : content.option1.title.en}
          </h3>
          <p className="text-sm mt-1 text-theme-color">
            {language
              ? content.option1.desc.hi
              : content.option1.desc.en}
          </p>
        </div>

        <div
          className="bg-white text-center py-4 px-6 rounded-md flex-1 shadow-md cursor-pointer hover:scale-105 transition-transform"
          onClick={() => navigate("/login")}
        >
          <h3 className="font-semibold text-lg text-theme-color">
            {language
              ? content.option2.title.hi
              : content.option2.title.en}
          </h3>
          <p className="text-sm mt-1 text-theme-color">
            {language
              ? content.option2.desc.hi
              : content.option2.desc.en}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SubsidyClaimRegistration;
